import { api } from './api';

/**
 * Billing Service for tenant payment management.
 */

class BillingService {
  /**
   * Get all available plans
   */
  async getPlans(authToken, tenant) {
    const response = await api.get('/v1/payments/plans', {
      headers: {
        'Authorization': 'Bearer ' + authToken,
        'tenant': tenant
      }
    });
    return response.data;
  }

  /**
   * Get billing status for a specific tenant
   */
  async getTenantBilling(authToken, tenant, tenantId) {
    const response = await api.get(`/v1/payments/tenant/${encodeURIComponent(tenantId)}/billing`, {
      headers: {
        'Authorization': 'Bearer ' + authToken,
        'tenant': tenant
      }
    });
    return response.data;
  }

  /**
   * Get current user's plan info (for tenant owners only)
   */
  async getMyPlan(authToken, tenant) {
    const response = await api.get('/v1/payments/my-plan', {
      headers: {
        'Authorization': 'Bearer ' + authToken,
        'tenant': tenant
      }
    });
    return response.data;
  }

  /**
   * Manually update tenant plan (admin override)
   */
  async updateTenantPlan(authToken, tenant, tenantId, plan) {
    const response = await api.post(
      `/v1/payments/tenant/${encodeURIComponent(tenantId)}/plan?plan=${encodeURIComponent(plan)}`,
      {},
      {
        headers: {
          'Authorization': 'Bearer ' + authToken,
          'tenant': tenant
        }
      }
    );
    return response.data;
  }
}

export const billingService = new BillingService();
export default billingService;
